import { useEffect, useState } from 'react';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { MenuServicio } from '../../service/MenuServicio';
import { useLazyParams } from '../../hooks/useLazyParams';
import { TablaDinamica } from '../../components/TablaDinamica';
import { MenuPermiso as MenuPermisoModel } from '../../models/administracion/MenuPermiso';
import { Generico } from '../../components/Generico';

// En la selección no se muestra la fecha de asignación
const { fecha, ...modeloSeleccion } = MenuPermisoModel;

export const MenuPermisoSeleccion = ({ id, toast, seleccionado, onAceptar, onCancelar }) => {

    const tablaEstado = useLazyParams({ modelo: modeloSeleccion });
    // Selección nativa del DataTable: con un RadioButton propio en el body la celda está memoizada y no se repinta
    const [seleccion, setSeleccion] = useState(seleccionado?.cat_id != null ? { id: seleccionado.cat_id } : null);
    const menuService = new MenuServicio();
    const { funcSistemaError } = Generico();

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tablaEstado.lazyParams, id]);

    const loadLazyData = () => {
        const params = { id: id, ...tablaEstado.lazyParams };
        tablaEstado.setLoading(true);
        menuService.getPermisos({ lazyEvent: JSON.stringify(params) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
        }).catch(error => {
            funcSistemaError(error, toast);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    };

    const handleAceptar = () => {
        if (seleccion?.controlador == null) {
            onAceptar(seleccionado);
            return;
        }
        onAceptar({ nombre: seleccion.controlador + ' - ' + seleccion.accion, cat_id: seleccion.id });
    };

    const ColumnaAcciones = (
        <Column header="Seleccionar" selectionMode="single" style={{ width: '10%' }} bodyStyle={{ textAlign: 'center' }} />
    );

    return (
        <>
            <TablaDinamica modelo={modeloSeleccion} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones}
                selectionMode="radiobutton" selection={seleccion} onSelectionChange={(e) => setSeleccion(e.value)} />
            <div className="flex justify-content-center gap-2 mt-3">
                <Button label="Aceptar" icon="pi pi-check" type="button" className="p-button-warning" style={{ maxWidth: '120px' }}
                    disabled={seleccion == null} onClick={handleAceptar} />
                <Button label="Cancelar" icon="pi pi-times" type="button" className="p-button-warning" style={{ maxWidth: '120px' }}
                    onClick={() => onCancelar()} />
            </div>
        </>
    );
};
